export enum CallStatus {
  NotConnected = 'Not Connected',
  Connected = 'Connected',
  HungUp = 'Hung Up',
  Missed = 'Missed',
  Mailbox = 'Mailbox',
  Answered = 'Answered',
  Login = 'Login',
  Logout = 'Logout',
}
